import * as React from "react";
import { Switch as SwitchPrimitive } from "radix-ui";

import { cn } from "@/utils/utils";
import { Icon } from "@/components/ui/Icon";

type SwitchProps = React.ComponentProps<typeof SwitchPrimitive.Root>;

/** Toggle controlado. O thumb e maior que o track e transborda, como no design. */
function Switch({ className, checked, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      checked={checked}
      className={cn(
        "inline-flex h-10 w-20 shrink-0 cursor-pointer items-center rounded-full transition-colors",
        "bg-[var(--surface-disabled-variant)]",
        "data-[state=checked]:bg-[var(--surface-primary-default-variant-3)]",
        "focus:outline-0 focus-visible:ring-2 focus-visible:ring-[var(--outline-others-focus)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none flex size-12 items-center justify-center rounded-full shadow-lg transition-transform",
          "-translate-x-[2px] data-[state=checked]:translate-x-[18px]",
          "bg-[var(--surface-default)]",
          "data-[state=checked]:bg-[var(--surface-primary-fixed-default)]"
        )}
      >
        {checked && (
          <Icon name="StreamlineEssentialCheck1Bold" size="xs" className="text-white" />
        )}
      </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
  );
}

export { Switch };
